import { render, staticRenderFns } from "./membershipTrade.vue?vue&type=template&id=498357d6&"
import script from "./membershipTrade.vue?vue&type=script&lang=ts&"
export * from "./membershipTrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "membershipTrade.vue"
export default component.exports